import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import RichTextEditor from './richtexteditor';



export const AddKPIModal = ({
  showaddkpi,
  setshowaddkpi,
  formData,
  setFormData,
  attributes,
  group_attributes,
  add_kpi,
  setloading,
}) => {
  // CSS to be included in your stylesheet or a style tag
  const customStyles = `
  
  .fancy-modal{
    padding:0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width:800px;
    max-height:800px;
    overflow-y:scroll;
    
    margin-top:10px;
    margin-left:300px !important;
  }
/* Fixed Add Task Modal Styles */
.fancy-modal .modal-content {
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: none;
  
  
}

.fancy-modal .modal-header {
  background: #8f11a8;
  color: white;
  padding: 20px 30px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.fancy-modal .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  margin: 0;
  color: white;
  font-size:28px;
}

.fancy-modal .modal-body {
  padding: 30px;
  background: white;
 
}

.fancy-modal .form-group {
  margin-bottom: 20px;
}

.fancy-modal .form-label {
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
  display: flex;
  align-items: center;
  
}


.fancy-modal .form-control,
.fancy-modal .form-select {
  border-radius: 8px !important;
  padding: 12px 15px !important;
  border: 1px solid #ddd !important;
 
  transition: all 0.2s ease;
  box-shadow: none !important;
  margin: 0 !important;
  background-color: white !important;
}
.fancy-modal .form-control{
height: 20px !important;
 width: 300px !important;
}
.fancy-modal .form-select{
 height: 47px !important;
 width: 335px !important;
}

.fancy-modal .form-control:focus,
.fancy-modal .form-select:focus {
  border-color: #1976D2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2) !important;
  outline: none !important;
}

.fancy-modal .form-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231976D2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 15px center !important;
  background-size: 15px !important;
  padding-right: 40px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  cursor: pointer;
}

.fancy-modal .status-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.fancy-modal .status-Pending { background-color: #FFC107; }
.fancy-modal .status-Done { background-color: #4CAF50; }
.fancy-modal .status-Overdue { background-color: #F44336; }

.fancy-modal .priority-High { background-color: #F44336; }
.fancy-modal .priority-Medium { background-color: #FFC107; }
.fancy-modal .priority-Low { background-color: #2196F3; }

.fancy-modal .modal-footer {
  background-color: #f8f9fa;
  border-top: none;
  padding: 20px 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.fancy-modal .btn {
  border-radius: 8px !important;
  padding: 12px 25px !important;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 135px;
  height: 45px;
}

.fancy-modal .btn-primary {
  background: linear-gradient(90deg, #1976D2, #3F51B5) !important;
  color: white !important;
}

.fancy-modal .btn-primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.fancy-modal .btn-secondary {
  background: #6c757d !important;
  color: white !important;
}

.fancy-modal .btn-secondary:hover {
  background: #5a6268 !important;
  opacity: 0.9;
}

.fancy-modal .quill-editor {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
  background: white;
}

.fancy-modal .quill-editor .ql-toolbar {
  border-bottom: 1px solid #ddd;
  background-color: #f8f9fa;
}

.fancy-modal .quill-editor .ql-container {
  min-height: 150px;
  font-size: 14px;
}

.fancy-modal .form-row {
  display: flex !important;
  gap:10px !important;
  
}


  

.fancy-modal .form-col {
  flex: 0 0 50% !important;
  max-width: 50% !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
  box-sizing: border-box !important;
  
}

.fancy-modal .form-col .form-group {
  margin-bottom: 20px !important;
}


.fancy-modal .modal-header .btn-close {
  position: absolute;
  top: 15px;
  right: 20px;
  color: white !important;
  font-size: 1.5rem;
  opacity: 0.9;
  z-index: 2;
}

.fancy-modal .modal-header .btn-close:hover {
  opacity: 1;
}

/* Override any conflicting Bootstrap styles */
.fancy-modal .modal-header .btn-close {
  margin: 0;
  padding: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .fancy-modal .form-col {
   flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  
  .fancy-modal .modal-body {
    padding: 20px;
  }

  .fancy-modal .form-group {
  margin-bottom: 20px !important;
  width: 100% !important;
}
  .fancy-modal .form-control {
  border-radius: 8px !important;
  padding: 12px 15px !important;
  border: 1px solid #ddd !important;
  width: 100% !important;
  height: 50px !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
  margin-left: 0 !important;
}

  

.fancy-modal .form-control:focus {
  border-color: #1976D2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2) !important;
}

.fancy-modal select.form-control {
  height: 50px !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231976D2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 15px center !important;
  background-size: 15px !important;
  padding-right: 40px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

  
  .fancy-modal .modal-footer {
    padding: 15px 20px;
    flex-direction: column;
    gap: 10px;
  }
  
  .fancy-modal .btn {
    width: 100%;
    justify-content: center;
  }
}

/* Fix for React Bootstrap modal backdrop */
.fancy-modal.modal {
  z-index: 1050;
}

.fancy-modal .modal-backdrop {
  z-index: 1040;
}

/* Ensure proper spacing and alignment */
.fancy-modal .mb-4 {
  margin-bottom: 1.5rem !important;
}

/* Fix textarea and rich text editor container */
.fancy-modal .form-group:last-child {
  margin-bottom: 0;
}

/* Icon alignment in buttons */
.fancy-modal .btn svg {
  width: 16px;
  height: 16px;
}

/* Form validation states */
.fancy-modal .form-control:invalid {
  border-color: #dc3545;
}

.fancy-modal .form-control:valid {
  border-color: #28a745;
}

.fancy-modal .form-control-color{
width: 75px !important;
height: 75px !important;
border:none !important;
background:transparent !important;
margin-top:-15px !important;
}
  `;


  const SaveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
      <polyline points="17 21 17 13 7 13 7 21"></polyline>
      <polyline points="7 3 7 8 15 8"></polyline>
    </svg>
  );

  const handleUpdate = () => {
    setloading(true);
    add_kpi();
    setloading(false);
  };

  

  const handleChange = (e) => {
    
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (name==='chartType'){
      setFormData(prevState => ({
        ...prevState,
        ['attribute_id']: ''
      }));
    }
  };

   const handleColorChange = (color) => {
    setFormData(prevState => ({
      ...prevState,
      chartColor: color
    }));
  };


  return (
    <>
      <style>{customStyles}</style>
      <Modal
        className="fancy-modal"
        
        size="lg"
        show={showaddkpi}
        onHide={() => setshowaddkpi(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title>Add KPI</Modal.Title>
           <button
            type="button"
            className="button-close"
            aria-label="Close"
            style={{
                height:"32px",
                width:"32px",
                display:"flex",
                background: "none",
                border: "1px solid white",
                borderRadius:"25px",
                cursor:"pointer",
                color:"white",
                fontSize:"28px",
                fontWeight:"normal",
                alignItems:"center",
            }}
            onClick={() => setshowaddkpi(false)}
        >X</button>
        </Modal.Header>
        <Modal.Body >
          <Form>
            <div className="form-row">
              <div className="form-col">
                <Form.Group className="mb-4">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name= 'blockName'
                    value={formData.blockName}
                    placeholder='Enter KPI Title'
                    onChange={handleChange}
                  />
                 
                </Form.Group>

               
                <Form.Group className="mb-4">
                  <Form.Label>Metric</Form.Label>
                  <Form.Select
                    name= 'attribute_id'
                    value={formData.attribute_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose...</option>
                    {(formData.chartType === 'number') && <option value="num_customers">Number of Customers</option>}
                    {attributes.map(attribute => (
                      <option key={attribute.id} value={attribute.name}>{attribute.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                
                 
        
                {(formData.chartType === 'line' || formData.chartType === 'bar') && (
                  <>
                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: '600' }}>Timeline</Form.Label>
                      <Form.Select
                        name= 'attribute_timeline'
                        value={formData.attribute_timeline}
                        onChange={handleChange}
                        >
                        <option value="">Choose...</option>
                        <option value="1">Yesterday</option>
                        <option value="7">Last 7 days</option>
                        <option value="30">Last 30 days</option>
                        <option value="45">Last 45 days</option>
                        <option value="60">Last 60 days</option>
                        <option value="90">Last 90 days</option>
                        <option value="365">Last 365 days</option>
                      </Form.Select>
                    </Form.Group>
        
                    
                  </>
                )}

                {!(formData.chartType === 'line' || formData.chartType === 'bar') || formData.attribute_agg !== 'count' ? (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600' }}>Group By</Form.Label>
                    <Form.Select
                        name= 'groupby_id'
                        value={formData.groupby_id}
                        onChange={handleChange}
                        >
                        <option value="">Choose...</option>
                        <option value="None">None</option>
                        {group_attributes.map(attribute => (
                          <option key={attribute.id} value={attribute.name}>{attribute.name}</option>
                        ))}
                      </Form.Select>
                  </Form.Group>
                ) : null}
               
        
                
        


                
              </div>

              <div className="form-col">
              

                <Form.Group className="mb-4">
                  <Form.Label>Type of Chart</Form.Label>
                  <Form.Select
                    name= 'chartType'
                    value={formData.chartType}
                    onChange={handleChange}
                  >
                    <option value="">Choose...</option>
                    <option value="number">Number</option>
                    <option value="pie">Pie/Doughnut Chart</option>
                    <option value="line">Line Chart</option>
                    <option value="bar">Vertical Bar Chart</option>
                  </Form.Select>
                </Form.Group>

               
                
                
                 {(formData.chartType !== 'pie') && (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600' }}>What do you wanna do with above metrics?</Form.Label>
                    <Form.Select
                    name= 'attribute_agg'
                    value={formData.attribute_agg}
                    onChange={handleChange}
                  >
                        <option value="">Choose...</option>
                        {((formData.chartType === 'line' || formData.chartType === 'bar') ||
                          (formData.chartType === 'number' && formData.attribute_id !== 'num_customers')) && (
                            <option value="count">Count</option>
                        )}
                        <option value="sum">Sum</option>
                        <option value="average">Average</option>
                   </Form.Select>
                  </Form.Group>
                )}
        
                {(formData.chartType === 'line' || formData.chartType === 'bar') && (
                  
                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: '600' }}>Timeline Aggregation</Form.Label>
                      <Form.Select
                        name= 'attribute_timeline_agg'
                        value={formData.attribute_timeline_agg}
                        onChange={handleChange}
                        >
                          <option value="">Choose...</option>
                          <option value="day">Day on Day</option>
                          <option value="week">Week on Week</option>
                          <option value="month">Month on Month</option>
                          <option value="quarter">Quarter on Quarter</option>
                        
                      </Form.Select>
                    </Form.Group>
                  
                )}
        
                
        
                {formData.chartType !== 'pie' && (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600'}}>Chart Color : </Form.Label>
                    
                    <Form.Control 
                      
                        type="color" name="chartColor" value={formData.chartColor} onChange={(e) => handleColorChange(e.target.value)} />
                  </Form.Group>
                )}
        


                
              </div>
              
            </div>

            
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div style={{
            display:"flex",
            marginLeft:"620px"
          }}>
            
            <Button
              variant="primary"
              className="d-flex align-items-center"
              onClick={handleUpdate}
              style={{width:"135px",gap:"10px"}}
            >
              <SaveIcon className="me-1" /> Add
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const EditKPIModal = ({
  showeditkpi,
  setshoweditkpi,
  formData,
  setFormData,
  attributes,
  group_attributes,
  edit_kpi,
  setloading,
}) => {
  // CSS to be included in your stylesheet or a style tag
  const customStyles = `
  
  .fancy-modal{
    padding:0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width:800px;
    max-height:800px;
    overflow-y:scroll;
    
    margin-top:10px;
    margin-left:300px !important;
  }
/* Fixed Add Task Modal Styles */
.fancy-modal .modal-content {
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: none;
  
  
}

.fancy-modal .modal-header {
  background: #8f11a8;
  color: white;
  padding: 20px 30px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.fancy-modal .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  margin: 0;
  color: white;
  font-size:28px;
}

.fancy-modal .modal-body {
  padding: 30px;
  background: white;
 
}

.fancy-modal .form-group {
  margin-bottom: 20px;
}

.fancy-modal .form-label {
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
  display: flex;
  align-items: center;
  
}


.fancy-modal .form-control,
.fancy-modal .form-select {
  border-radius: 8px !important;
  padding: 12px 15px !important;
  border: 1px solid #ddd !important;
 
  transition: all 0.2s ease;
  box-shadow: none !important;
  margin: 0 !important;
  background-color: white !important;
}
.fancy-modal .form-control{
height: 20px !important;
 width: 300px !important;
}
.fancy-modal .form-select{
 height: 47px !important;
 width: 335px !important;
}

.fancy-modal .form-control:focus,
.fancy-modal .form-select:focus {
  border-color: #1976D2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2) !important;
  outline: none !important;
}

.fancy-modal .form-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231976D2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 15px center !important;
  background-size: 15px !important;
  padding-right: 40px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  cursor: pointer;
}

.fancy-modal .status-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.fancy-modal .status-Pending { background-color: #FFC107; }
.fancy-modal .status-Done { background-color: #4CAF50; }
.fancy-modal .status-Overdue { background-color: #F44336; }

.fancy-modal .priority-High { background-color: #F44336; }
.fancy-modal .priority-Medium { background-color: #FFC107; }
.fancy-modal .priority-Low { background-color: #2196F3; }

.fancy-modal .modal-footer {
  background-color: #f8f9fa;
  border-top: none;
  padding: 20px 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.fancy-modal .btn {
  border-radius: 8px !important;
  padding: 12px 25px !important;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 135px;
  height: 45px;
}

.fancy-modal .btn-primary {
  background: linear-gradient(90deg, #1976D2, #3F51B5) !important;
  color: white !important;
}

.fancy-modal .btn-primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

.fancy-modal .btn-secondary {
  background: #6c757d !important;
  color: white !important;
}

.fancy-modal .btn-secondary:hover {
  background: #5a6268 !important;
  opacity: 0.9;
}

.fancy-modal .quill-editor {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
  background: white;
}

.fancy-modal .quill-editor .ql-toolbar {
  border-bottom: 1px solid #ddd;
  background-color: #f8f9fa;
}

.fancy-modal .quill-editor .ql-container {
  min-height: 150px;
  font-size: 14px;
}

.fancy-modal .form-row {
  display: flex !important;
  gap:10px !important;
  
}


  

.fancy-modal .form-col {
  flex: 0 0 50% !important;
  max-width: 50% !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
  box-sizing: border-box !important;
  
}

.fancy-modal .form-col .form-group {
  margin-bottom: 20px !important;
}


.fancy-modal .modal-header .btn-close {
  position: absolute;
  top: 15px;
  right: 20px;
  color: white !important;
  font-size: 1.5rem;
  opacity: 0.9;
  z-index: 2;
}

.fancy-modal .modal-header .btn-close:hover {
  opacity: 1;
}

/* Override any conflicting Bootstrap styles */
.fancy-modal .modal-header .btn-close {
  margin: 0;
  padding: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .fancy-modal .form-col {
   flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  
  .fancy-modal .modal-body {
    padding: 20px;
  }

  .fancy-modal .form-group {
  margin-bottom: 20px !important;
  width: 100% !important;
}
  .fancy-modal .form-control {
  border-radius: 8px !important;
  padding: 12px 15px !important;
  border: 1px solid #ddd !important;
  width: 100% !important;
  height: 50px !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
  margin-left: 0 !important;
}

  

.fancy-modal .form-control:focus {
  border-color: #1976D2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2) !important;
}

.fancy-modal select.form-control {
  height: 50px !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231976D2' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 15px center !important;
  background-size: 15px !important;
  padding-right: 40px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

  
  .fancy-modal .modal-footer {
    padding: 15px 20px;
    flex-direction: column;
    gap: 10px;
  }
  
  .fancy-modal .btn {
    width: 100%;
    justify-content: center;
  }
}

/* Fix for React Bootstrap modal backdrop */
.fancy-modal.modal {
  z-index: 1050;
}

.fancy-modal .modal-backdrop {
  z-index: 1040;
}

/* Ensure proper spacing and alignment */
.fancy-modal .mb-4 {
  margin-bottom: 1.5rem !important;
}

/* Fix textarea and rich text editor container */
.fancy-modal .form-group:last-child {
  margin-bottom: 0;
}

/* Icon alignment in buttons */
.fancy-modal .btn svg {
  width: 16px;
  height: 16px;
}

/* Form validation states */
.fancy-modal .form-control:invalid {
  border-color: #dc3545;
}

.fancy-modal .form-control:valid {
  border-color: #28a745;
}

.fancy-modal .form-control-color{
width: 75px !important;
height: 75px !important;
border:none !important;
background:transparent !important;
margin-top:-15px !important;
}
  `;


  const SaveIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
      <polyline points="17 21 17 13 7 13 7 21"></polyline>
      <polyline points="7 3 7 8 15 8"></polyline>
    </svg>
  );

  const handleUpdate = () => {
    setloading(true);
    edit_kpi();
    setloading(false);
  };

  

  const handleChange = (e) => {
    
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (name==='chartType'){
      setFormData(prevState => ({
        ...prevState,
        ['attribute_id']: ''
      }));
    }
  };

   const handleColorChange = (color) => {
    setFormData(prevState => ({
      ...prevState,
      chartColor: color
    }));
  };


  return (
    <>
      <style>{customStyles}</style>
      <Modal
        className="fancy-modal"
        
        size="lg"
        show={showeditkpi}
        onHide={() => setshoweditkpi(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title>Edit KPI</Modal.Title>
           <button
            type="button"
            className="button-close"
            aria-label="Close"
            style={{
                height:"32px",
                width:"32px",
                display:"flex",
                background: "none",
                border: "1px solid white",
                borderRadius:"25px",
                cursor:"pointer",
                color:"white",
                fontSize:"28px",
                fontWeight:"normal",
                alignItems:"center",
            }}
            onClick={() => setshoweditkpi(false)}
        >X</button>
        </Modal.Header>
        <Modal.Body >
          <Form>
            <div className="form-row">
              <div className="form-col">
                <Form.Group className="mb-4">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name= 'blockName'
                    value={formData.blockName}
                    placeholder='Enter KPI Title'
                    onChange={handleChange}
                  />
                 
                </Form.Group>

               
                <Form.Group className="mb-4">
                  <Form.Label>Metric</Form.Label>
                  <Form.Select
                    name= 'attribute_id'
                    value={formData.attribute_id}
                    onChange={handleChange}
                  >
                    <option value="">Choose...</option>
                    {(formData.chartType === 'number') && <option value="num_customers">Number of Customers</option>}
                    {attributes.map(attribute => (
                      <option key={attribute.id} value={attribute.name}>{attribute.name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                
                 
        
                {(formData.chartType === 'line' || formData.chartType === 'bar') && (
                  <>
                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: '600' }}>Timeline</Form.Label>
                      <Form.Select
                        name= 'attribute_timeline'
                        value={formData.attribute_timeline}
                        onChange={handleChange}
                        >
                        <option value="">Choose...</option>
                        <option value="1">Yesterday</option>
                        <option value="7">Last 7 days</option>
                        <option value="30">Last 30 days</option>
                        <option value="45">Last 45 days</option>
                        <option value="60">Last 60 days</option>
                        <option value="90">Last 90 days</option>
                        <option value="365">Last 365 days</option>
                      </Form.Select>
                    </Form.Group>
        
                    
                  </>
                )}

                {!(formData.chartType === 'line' || formData.chartType === 'bar') || formData.attribute_agg !== 'count' ? (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600' }}>Group By</Form.Label>
                    <Form.Select
                        name= 'groupby_id'
                        value={formData.groupby_id}
                        onChange={handleChange}
                        >
                        <option value="">Choose...</option>
                        <option value="None">None</option>
                        {group_attributes.map(attribute => (
                          <option key={attribute.id} value={attribute.name}>{attribute.name}</option>
                        ))}
                      </Form.Select>
                  </Form.Group>
                ) : null}
               
        
                
        


                
              </div>

              <div className="form-col">
              

                <Form.Group className="mb-4">
                  <Form.Label>Type of Chart</Form.Label>
                  <Form.Select
                    name= 'chartType'
                    value={formData.chartType}
                    onChange={handleChange}
                  >
                    <option value="">Choose...</option>
                    <option value="number">Number</option>
                    <option value="pie">Pie/Doughnut Chart</option>
                    <option value="line">Line Chart</option>
                    <option value="bar">Vertical Bar Chart</option>
                  </Form.Select>
                </Form.Group>

               
                
                
                 {(formData.chartType !== 'pie') && (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600' }}>What do you wanna do with above metrics?</Form.Label>
                    <Form.Select
                    name= 'attribute_agg'
                    value={formData.attribute_agg}
                    onChange={handleChange}
                  >
                        <option value="">Choose...</option>
                        {((formData.chartType === 'line' || formData.chartType === 'bar') ||
                          (formData.chartType === 'number' && formData.attribute_id !== 'num_customers')) && (
                            <option value="count">Count</option>
                        )}
                        <option value="sum">Sum</option>
                        <option value="average">Average</option>
                   </Form.Select>
                  </Form.Group>
                )}
        
                {(formData.chartType === 'line' || formData.chartType === 'bar') && (
                  
                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: '600' }}>Timeline Aggregation</Form.Label>
                      <Form.Select
                        name= 'attribute_timeline_agg'
                        value={formData.attribute_timeline_agg}
                        onChange={handleChange}
                        >
                          <option value="">Choose...</option>
                          <option value="day">Day on Day</option>
                          <option value="week">Week on Week</option>
                          <option value="month">Month on Month</option>
                          <option value="quarter">Quarter on Quarter</option>
                        
                      </Form.Select>
                    </Form.Group>
                  
                )}
        
                
        
                {formData.chartType !== 'pie' && (
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: '600'}}>Chart Color : </Form.Label>
                    
                    <Form.Control 
                      
                        type="color" name="chartColor" value={formData.chartColor} onChange={(e) => handleColorChange(e.target.value)} />
                  </Form.Group>
                )}
        


                
              </div>
              
            </div>

            
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div style={{
            display:"flex",
            marginLeft:"620px"
          }}>
            
            <Button
              variant="primary"
              className="d-flex align-items-center"
              onClick={handleUpdate}
              style={{width:"135px",gap:"10px"}}
            >
              <SaveIcon className="me-1" /> Update
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
